import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "ai-login-backdrop",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "floating-particles" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"light-beam beam-left\" data-v-2db47b0a></div><div class=\"light-beam beam-right\" data-v-2db47b0a></div><div class=\"ambient-haze haze-top\" data-v-2db47b0a></div><div class=\"ambient-haze haze-bottom\" data-v-2db47b0a></div><div class=\"hud-panel hud-panel--left\" data-v-2db47b0a></div><div class=\"hud-panel hud-panel--right\" data-v-2db47b0a></div><div class=\"energy-floor\" data-v-2db47b0a></div><div class=\"energy-floor energy-floor--inner\" data-v-2db47b0a></div><div class=\"grid-mask\" data-v-2db47b0a></div>", 9)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.particles, (particle) => {
        return (_openBlock(), _createElementBlock("span", {
          key: particle.id,
          class: "particle",
          style: _normalizeStyle(particle.style)
        }, null, 4))
      }), 128))
    ])
  ]))
}